const list = ['D847','K749','OG70','ON02','PK87','X918'];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

const ex_data = {
    'A0013': '|cFF07af03仙术积分加成卡（初级）|r|n|cFFFFFFFF加成仙术积分奖励：|n|n|cFFFFFF00基础仙术积分*|cFFD9001B10%|r|n|n|cff02A7F0在【执笔绘春 乘风归】网页活动中有效，可额外加成基础仙术积分',
    'A0014': '|cFF298cfb仙术积分加成卡（中级）|r|n|cFFFFFFFF加成仙术积分奖励：|n|n|cFFFFFF00基础仙术积分*|cFFD9001B20%|r|n|n|cff02A7F0在【执笔绘春 乘风归】网页活动中有效，可额外加成基础仙术积分',
    'A0015': '|cFFffd631仙术积分加成卡（高级）|r|n|cFFFFFFFF加成仙术积分奖励：|n|n|cFFFFFF00基础仙术积分*|cFFD9001B30%|r|n|n|cff02A7F0在【执笔绘春 乘风归】网页活动中有效，可额外加成基础仙术积分',
    'A0016': '|cFFd6a172仙术积分加成卡（特级）|r|n|cFFFFFFFF加成仙术积分奖励：|n|n|cFFFFFF00基础仙术积分*|cFFD9001B50%|r|n|n|cff02A7F0在【执笔绘春 乘风归】网页活动中有效，可额外加成基础仙术积分',    
}

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
    ex_data,
}